/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTallymark2 = createReactComponent("tallymark-2", "IconTallymark2", [
  ["path", { d: "M10 5l0 14", key: "svg-0" }],
  ["path", { d: "M14 5l0 14", key: "svg-1" }]
]);

export { IconTallymark2 as default };
//# sourceMappingURL=IconTallymark2.js.map
